import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table"
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences"
import TableToolbar from "../Common/table/TableToolbar"

const auditLogHeaders = ["Created Date", "Updated Date", "Created By", "Updated By"]

export const AuditLog = (props) => {
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("primaryplayerAuditLog", auditLogHeaders)

  const close = () => {
    props.setOpenAuditLog(false)
  }

  return (
    <React.Fragment>
      <Dialog open={props.openAuditLog} onOpenChange={close}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold">Player Audit Log</DialogTitle>
          </DialogHeader>
          <div className="relative rounded-lg border bg-card overflow-y-auto flex-1 min-h-0">
            <TableToolbar
              columns={allColumns}
              onToggle={toggleVisibility}
              onReorder={reorder}
              onReset={resetToDefault}
            />
            <Table className="w-full text-center">
              <TableHeader className="bg-muted">
                <TableRow>
                  {visibleIndices.map((origIdx) => (
                    <TableHead key={origIdx} className="text-center">{auditLogHeaders[origIdx]}</TableHead>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell colSpan={visibleIndices.length} className="text-xs text-muted-foreground py-6">
                    No audit records available
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

export default AuditLog;
